var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';
import t from 'prop-types';
import EntradaTipoCategoria from './entrada-tipo-categoria';
import EntradaTipoRepaso from './entrada-tipo-repaso';
import EntradaTipoSubunidad from './entrada-tipo-subunidad';
import EntradaTipoUnidad from './entrada-tipo-unidad';
import EntradaTipoLeccion from './entrada-tipo-leccion';
import EntradaTipoGenerica from './entrada-tipo-generica';
import EntradaTipoAdorno from './entrada-tipo-adorno';
import EntradaTipoBotonLibro from './entrada-tipo-boton-libro';
import EntradaTipoVolverAMenu from './entrada-tipo-volver-a-menu';
import EntradaTipoPdf from './entrada-tipo-pdf';
var Entradas = {
  'subUnidad': EntradaTipoSubunidad,
  'categoria': EntradaTipoCategoria,
  'repasoIndice': EntradaTipoRepaso,
  'leccion': EntradaTipoLeccion,
  'unidad': EntradaTipoUnidad,
  'generica': EntradaTipoGenerica,
  'adorno': EntradaTipoAdorno,
  'botonLibro': EntradaTipoBotonLibro,
  'volverAMenu': EntradaTipoVolverAMenu,
  'pdf': EntradaTipoPdf
};

var Entrada = function Entrada(_ref) {
  var clase = _ref.clase,
      props = _objectWithoutProperties(_ref, ['clase']);

  var tipo = clase.split(' ')[0];
  var EntradaTipo = Entradas[tipo] || EntradaTipoGenerica;
  return React.createElement(EntradaTipo, _extends({
    clase: clase
  }, props));
};

Entrada.propTypes = process.env.NODE_ENV !== "production" ? {
  clase: t.string
} : {};
export default Entrada;